'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a button for going back one page in the form.
 * @extends {Component}
 */
var BackButtonComponent = function (_React$Component) {
  _inherits(BackButtonComponent, _React$Component);

  function BackButtonComponent() {
    _classCallCheck(this, BackButtonComponent);

    return _possibleConstructorReturn(this, (BackButtonComponent.__proto__ || Object.getPrototypeOf(BackButtonComponent)).apply(this, arguments));
  }

  _createClass(BackButtonComponent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Button,
        {
          bsStyle: 'primary',
          className: 'ingle-form-back-button button',
          disabled: this.props.isFormSubmitting || (0, _url2.default)('form') === 'editable',
          onClick: this.props.onClick
        },
        this.props.children
      );
    }
  }]);

  return BackButtonComponent;
}(_react2.default.Component);

BackButtonComponent.propTypes = {
  isFormSubmitting: _react2.default.PropTypes.bool.isRequired,
  onClick: _react2.default.PropTypes.func.isRequired,
  children: _react2.default.PropTypes.string.isRequired
};
BackButtonComponent.defaultProps = {
  children: 'Back'
};
exports.default = BackButtonComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/BackButtonComponent.jsx
// module id = 1672
// module chunks = 0